// Configuração centralizada das APIs
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || ''

export const API_ENDPOINTS = {
    // Reports API
    REPORTS: {
        BASE: '/api/v1/reports',
        METRICS: '/api/v1/reports/metrics/',
        KPIS: '/api/v1/reports/kpis/',
        REPORTS: '/api/v1/reports/reports/',
        EXECUTIONS: '/api/v1/reports/executions/',
        PRESET_METRICS: '/api/v1/reports/preset-metrics/',
        DASHBOARD: '/api/v1/reports/dashboard/',
        TABLES: '/api/v1/reports/tables/',
        FIELDS: (tableName) => `/api/v1/reports/fields/${tableName}/`,
        CUSTOM_REPORTS: '/api/v1/reports/custom-reports/',
        METRIC_BUILDER: '/api/v1/reports/metric-builder/',
    },
    
    // Schedules API
    SCHEDULES: {
        BASE: '/api/v1/schedules',
        DOCTORS: '/api/v1/schedules/doctors/list/',
        APPOINTMENTS: '/api/v1/schedules/appointments/',
    },
    
    // Patients API
    PATIENTS: {
        BASE: '/api/v1/patients',
        LIST: '/api/v1/patients/',
    },
    
    // Medical Reports API
    MEDICAL_REPORTS: {
        BASE: '/api/v1/medical-reports',
        LAUDOS: '/api/v1/medical-reports/laudos/',
    },
    
    // Doctors API
    DOCTORS: {
        BASE: '/api/v1/doctors',
        LIST: '/api/v1/doctors/',
    },
    
    // Services API
    SERVICES: {
        BASE: '/api/v1/services',
        LIST: '/api/v1/services/',
    },
    
    // EditExam API
    EDIT_EXAM: {
        BASE: '/api/v1/editexam',
        STUDIES: '/api/v1/editexam/studies/',
        MODALITIES: '/api/v1/editexam/modalities/',
        LOGS: '/api/v1/editexam/logs/',
    }
}

export const getApiUrl = (endpoint) => {
    return `${API_BASE_URL}${endpoint}`
}

export default API_ENDPOINTS 